import React, { useState } from "react";
import {
  exportXlsxTablesDatabase,
  getDatabaseData,
  importXlsxTablesDatabase,
} from "../../services/databaseService";
import { Card, Table, Button, Badge, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { useQuery } from "react-query";

const TABLES = [
  // "users",
  // "regions",
  // "district",
  // "sub_district",
  // "questionary",
  // "questionary_data",
  "housing_data",
  "building_assessment",
  "spatial_data",
  "per_capita_area",
  "water_access",
  "sanitation_access",
  // "data_collection_info",
  // "sync_log",
];

const DatabaseManager = () => {
  const [selectedTables, setSelectedTables] = useState([]);
  const [exportLoading, setExportLoading] = useState(false);
  const [importLoading, setImportLoading] = useState(false);
  const [importFile, setImportFile] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [tableToDelete, setTableToDelete] = useState(null);

  const {
    data: databaseData,
    isLoading,
    error,
    refetch,
  } = useQuery(
    ["databaseData", currentPage],
    () => getDatabaseData({ page: currentPage }),
    { keepPreviousData: true }
  );

  const handleTableSelect = (table) => {
    setSelectedTables((prev) =>
      prev.includes(table) ? prev.filter((t) => t !== table) : [...prev, table]
    );
  };

  const handleExport = async (tablesToExport = selectedTables) => {
    const actifiedFiture = true;
    if (actifiedFiture) {
      if (!tablesToExport || tablesToExport.length === 0) {
        toast.warning("Pilih minimal satu tabel untuk diekspor");
        return;
      }
      setExportLoading(true);
      try {
        await exportXlsxTablesDatabase(tablesToExport);
        toast.success("Export berhasil");
      } catch (err) {
        toast.error("Export gagal");
      }
      setExportLoading(false);
    } else {
      toast.error("Export gagal. Fitur export data belum diaktifkan");
      return;
    }
  };

  const handleImport = async () => {
    const actifiedFiture = true;
    if (actifiedFiture) {
      if (!importFile || selectedTables.length === 0) {
        toast.warning("Pilih file dan tabel tujuan");
        return;
      }
      setImportLoading(true);
      try {
        await importXlsxTablesDatabase(selectedTables, importFile);
        toast.success("Import berhasil");
        refetch();
      } catch (err) {
        toast.error("Import gagal");
      }
      setImportLoading(false);
    } else {
      toast.error(`Import gagal. Fitur import data belum diaktifkan`);
      return;
    }
  };

  // Buka modal untuk konfirmasi
  const handleTruncateClick = (table) => {
    const actifiedFiture = false;
    if (actifiedFiture) {
      setTableToDelete(table);
      setShowDeleteModal(true);
    } else {
      toast.error(`Fitur hapus tabel belum diaktifkan`);
      return;
    }
  };

  // Eksekusi hapus setelah user konfirmasi
  // const confirmDelete = async () => {
    // if (!tableToDelete) return;
    // try {
      // Panggil API truncate sesuai service kamu
      // await truncateTable(tableToDelete);
      // toast.success(`Tabel ${tableToDelete} berhasil dihapus`);
      // refetch();
    // } catch (err) {
      // toast.error(`Gagal menghapus tabel ${tableToDelete}`);
    // }
    // setShowDeleteModal(false);
    // setTableToDelete(null);
  // };

  if (isLoading) return <div className="loading-spinner">Loading...</div>;
  if (error) return <div className="error-message">Error: {error.message}</div>;

  return (
    <div className="container-fluid">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2>Manajemen BasisData</h2>
      </div>
      <Card>
        <Card.Body>
          <Table responsive striped hover>
            <thead>
              <tr>
                <th>No</th>
                <th>Nama Tabel</th>
                <th>Keterangan</th>
                <th>Jenis</th>
                <th>Jumlah Record(s)</th>
                <th>Aksi</th>
              </tr>
            </thead>
            <tbody>
              {databaseData?.data?.map((t, index) => (
                <tr key={t.id || t.name}>
                  <td>{(currentPage - 1) * 10 + index + 1}</td>
                  <td>{t.name}</td>
                  <td>{t.explanations}</td>
                  <td>
                    <Badge
                      className="p-2 col-10"
                      bg={
                        t.role === "Master"
                          ? "danger"
                          : t.role === "Transaksi"
                          ? "success"
                          : "warning"
                      }
                    >
                      {t.role}
                    </Badge>
                  </td>
                  <td>{t.records}</td>
                  <td>
                    <div className="group-this-items">
                      <Button
                        size="sm"
                        variant="info"
                        className="me-3 action-btn"
                        onClick={() => handleExport([t.name])}
                      >
                        <i className="fas fa-file-export"></i>
                      </Button>
                      {/* <Button
                        size="sm"
                        variant="warning"
                        className="me-3 action-btn"
                        onClick={() => {
                          setSelectedTables([t.name]);
                          document.getElementById("fileImportInput").click();
                        }}
                      >
                        <i className="fas fa-file-import"></i>
                      </Button> */}
                      <Button
                        size="sm"
                        variant={t.role === "Master" ? "secondary" : "danger"}
                        className="me-3 action-btn"
                        onClick={() => handleTruncateClick(t.name)}
                        disabled={t.role === "Master"}
                      >
                        <i className="fas fa-trash"></i>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>

          {/* Pagination */}
          {databaseData?.pagination && (
            <div className="d-flex justify-content-between align-items-center">
              <div>
                Menampilkan {databaseData.pagination.from} -{" "}
                {databaseData.pagination.to} dari{" "}
                {databaseData.pagination.total} data
              </div>
              <div>
                <Button
                  variant="outline-primary"
                  size="sm"
                  disabled={currentPage === 1}
                  onClick={() => setCurrentPage(currentPage - 1)}
                  className="me-2"
                >
                  Sebelumnya
                </Button>
                <Button
                  variant="outline-primary"
                  size="sm"
                  disabled={currentPage >= databaseData.pagination.last_page}
                  onClick={() => setCurrentPage(currentPage + 1)}
                >
                  Selanjutnya
                </Button>
              </div>
            </div>
          )}

          {/* Checkbox pilihan tabel */}
          <div className="mt-4">
            <strong>Pilih Tabel:</strong>
            <div className="d-flex flex-wrap gap-2 mt-2">
              {TABLES.map((table) => (
                <label key={table} className="form-check-label">
                  <input
                    type="checkbox"
                    className="form-check-input me-1"
                    checked={selectedTables.includes(table)}
                    onChange={() => handleTableSelect(table)}
                  />
                  {table}
                </label>
              ))}
            </div>
          </div>

          {/* Tombol Export & Import */}
          <div className="mt-3">
            <button
              className="btn btn-primary me-2"
              onClick={() => handleExport()}
              disabled={exportLoading}
            >
              {exportLoading ? "Exporting..." : "Export XLSX (ZIP)"}
            </button>
            <input
              type="file"
              id="fileImportInput"
              accept=".xlsx,.csv,.zip"
              onChange={(e) => setImportFile(e.target.files[0])}
              className="form-control d-inline-block w-auto"
              style={{ display: "inline-block" }}
            />
            <button
              className="btn btn-success ms-2"
              onClick={handleImport}
              disabled={importLoading}
            >
              {importLoading ? "Importing..." : "Import XLSX/CSV"}
            </button>
          </div>
        </Card.Body>
      </Card>

      {/* Modal Konfirmasi Hapus */}
      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Konfirmasi Hapus</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {`Yakin ingin menghapus semua data di tabel "${tableToDelete}"?`}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
            Batal
          </Button>
          {/* <Button variant="danger" onClick={confirmDelete}>
            Hapus
          </Button> */}
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default DatabaseManager;
